import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuality = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.716 1.599c.525-1.065 2.043-1.065 2.568 0l1.857 3.766 4.137.617c1.167.174 1.634 1.605.795 2.434l-2.994 2.957.696 4.16c.196 1.168-1.03 2.054-2.078 1.503L9 15.09l-3.697 1.946c-1.048.551-2.274-.335-2.078-1.503l.696-4.16L.927 8.416c-.84-.829-.372-2.26.795-2.434l4.137-.617 1.857-3.766zM9 2.23L6.811 6.67l-4.878.728 3.523 3.479-.82 4.892L9 13.472l4.364 2.297-.82-4.892 3.523-3.48-4.878-.727L9 2.23z",
		fillRule: "evenodd"
	})
});
export default SvgQuality;
